<h2 mat-dialog-title>{{ "PASSENGERS.ASSIGNED.managePassenger" | translate }}</h2>
<mat-dialog-content class="mat-typography">
    <!--  [formGroup]="passengerFormGroup" -->
    <form #passengersForm="ngForm" fxFlex="100" (ngSubmit)="onFormSubmit()" [formGroup]="passengersListFormGroup">
        <mat-tab-group mat-align-tabs="center" formArrayName="passenger" [color]="'primary'" #tabGroup [selectedIndex]="tabIndex">
            @for (item of formArry.controls; track item; let i = $index) {
                <mat-tab [label]="item.get('firstName').value + ' ' + item.get('lastName').value" [formGroupName]="i">
                    <!-- <ng-template matTabContent> -->
                    <div class="pt-10">
                        <app-form-group-title [title]="'PASSENGERS.ASSIGNED.passenger' | translate"></app-form-group-title>
                        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px" class="mt-15">
                            <mat-form-field fxFlex="25" appearance="outline" [floatLabel]="'always'">
                                <mat-label>{{ "PASSENGERS.ASSIGNED.passengerWeight" | translate }}</mat-label>
                                <input
                                    matInput
                                    [placeholder]="'PASSENGERS.ASSIGNED.passengerWeight' | translate"
                                    name="passengerWeight"
                                    formControlName="passengerWeight"
                                    type="number"
                                    min="0"
                                />
                                <span matSuffix>kg</span>
                                @if (item.get("passengerWeight").hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <app-form-group-title [title]="'PASSENGERS.ASSIGNED.luggage' | translate"></app-form-group-title>
                        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px" class="mt-15">
                            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                                <mat-label>{{ "PASSENGERS.ASSIGNED.luggageWeight" | translate }}</mat-label>
                                <input
                                    matInput
                                    [placeholder]="'PASSENGERS.ASSIGNED.luggageWeight' | translate"
                                    name="luggageWeight"
                                    formControlName="luggageWeight"
                                    type="number"
                                    min="0"
                                />
                                <span matSuffix>kg</span>
                                @if (item.get("luggageWeight").hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                                <mat-label>{{ "PASSENGERS.ASSIGNED.luggageLength" | translate }}</mat-label>
                                <input
                                    matInput
                                    [placeholder]="'PASSENGERS.ASSIGNED.luggageLength' | translate"
                                    name="luggageLength"
                                    formControlName="luggageLength"
                                    type="number"
                                    min="0"
                                />
                                <span matSuffix>cm</span>
                                @if (item.get("luggageLength").hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                                <mat-label>{{ "PASSENGERS.ASSIGNED.luggageWidth" | translate }}</mat-label>
                                <input
                                    matInput
                                    [placeholder]="'PASSENGERS.ASSIGNED.luggageWidth' | translate"
                                    name="luggageWidth"
                                    formControlName="luggageWidth"
                                    type="number"
                                    min="0"
                                />
                                <span matSuffix>cm</span>
                                @if (item.get("luggageWidth").hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                                <mat-label>{{ "PASSENGERS.ASSIGNED.luggageHeight" | translate }}</mat-label>
                                <input
                                    matInput
                                    [placeholder]="'PASSENGERS.ASSIGNED.luggageHeight' | translate"
                                    name="luggageHeight"
                                    formControlName="luggageHeight"
                                    type="number"
                                    min="0"
                                />
                                <span matSuffix>cm</span>
                                @if (item.get("luggageHeight").hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </div>
                    <!-- </ng-template> -->
                </mat-tab>
            }
        </mat-tab-group>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="warn" [mat-dialog-close]="true" cdkFocusInitial>{{ "GENERAL.cancel" | translate }}</button>
    <button mat-raised-button color="primary" (click)="passengersForm.ngSubmit.emit()">
        {{ "GENERAL.save" | translate }}
    </button>
</mat-dialog-actions>
